import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';

export default {
  nodeMoveStart(e, movingNode, docNode) {
    document.body.style.userSelect = 'none';

    const targetBBox = e.target.getBoundingClientRect();
    const xOffset = e.clientX - targetBBox.left;
    const yOffset = e.clientY - targetBBox.top;

    const nodes = this.domNodes;
    const pigeonDoc = this.document;
    const documentRef = this.$refs.document;

    const placeholder = new PigeonDocNodeModel({ type: 'placeholder' });
    placeholder.meta.height = movingNode.getBoundingClientRect().height;
    pigeonDoc.insertBefore({
      insert: placeholder,
      before: docNode,
    });

    movingNode.style.position = 'fixed';
    movingNode.style.top = e.clientY - yOffset + 'px';
    movingNode.style.left = e.clientX - xOffset + 'px';

    function mousemovelistener(e) {
      movingNode.style.top = e.clientY - yOffset + 'px';
      movingNode.style.left = e.clientX - xOffset + 'px';

      // Find node in document that moving node is currently hovering above
      nodes.forEach((vueNode) => {
        const rect = vueNode.$el.getBoundingClientRect();

        if (
          vueNode.value.uuid != docNode.uuid &&
          e.clientX + 50 > rect.left &&
          e.clientX < rect.right &&
          e.clientY > rect.top &&
          e.clientY < rect.bottom
        ) {
          if (vueNode.value.uuid != placeholder.uuid) {
            pigeonDoc.removeNode(placeholder);

            if (e.clientY > rect.top + rect.height / 2) {
              pigeonDoc.insertAfter({
                insert: placeholder,
                after: vueNode.value,
              });
            } else {
              pigeonDoc.insertBefore({
                insert: placeholder,
                before: vueNode.value,
              });
            }
          }
        }
      });

      if (e.clientY < 100) {
        window.scrollBy(0, -5);
      }

      if (document.documentElement.clientHeight - e.clientY < 100) {
        window.scrollBy(0, 5);
      }
    }

    documentRef.addEventListener('mousemove', mousemovelistener);

    function mouseupListener() {
      pigeonDoc.removeNode(docNode);
      pigeonDoc.insertAfter({
        insert: docNode,
        after: placeholder,
      });
      pigeonDoc.removeNode(placeholder);

      documentRef.removeEventListener('mousemove', mousemovelistener);
      window.removeEventListener('mouseup', mouseupListener);

      document.body.style.userSelect = 'auto';
      movingNode.style.removeProperty('position');
      movingNode.style.removeProperty('top');
      movingNode.style.removeProperty('left');
    }

    window.addEventListener('mouseup', mouseupListener);
  },
};
